import React from 'react'
import styled from 'styled-components'

const BadgeContainer = styled.div`
  width: 24px;
  height: 16px;
  border-radius: 10px;
  background-color: ${props => (props.selected ? '#282e45' : '#3395fe')};
  color: ${props => (props.selected ? '#3395fe' : '#282e45')};
  font-size: 8pt;
  font-weight: 600;
  position: absolute;
  right: 6px;
  top: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Badge = props => {
  const {value, selected} = props
  return value > 0 ? (
    <BadgeContainer data-testid="badge-container" selected={selected}>
      {value}
    </BadgeContainer>
  ) : null
}

Badge.defaultProps = {
  selected: false,
  value: 0
}

export default Badge
